import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseData } from '../models/helpers.model';
import { Company, CompanyLite } from '../models/customer.model';
import { FilterOptions } from '../models/filter.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(private http: HttpClient) {}

  getCompanies(
    filterOptions: FilterOptions
  ): Observable<ResponseData<Company>> {
    return this.http.post<ResponseData<Company>>(
      '/companies/filter',
      filterOptions
    );
  }

  getCompaniesLite(
    filterOptions: FilterOptions
  ): Observable<ResponseData<CompanyLite>> {
    return this.http.post<ResponseData<CompanyLite>>(
      '/companies/lite/filter',
      filterOptions
    );
  }

  getCompany(id: string): Observable<Company> {
    return this.http.get<Company>(`/companies/${id}`);
  }

  setKeyPerson(id: string, data: { userId: string }): Observable<string> {
    return this.http.put<string>(`/companies/${id}/set-key-person`, data);
  }

  // updateCompany(id: string, data: any): Observable<any> {
  //   return this.http.put<any>(`/companies/${id}`, data);
  // }

  // deleteCompany(id: string): Observable<any> {
  //   return this.http.delete<any>(`/companies/${id}`);
  // }

  // createCompany(data: any): Observable<any> {
  //   return this.http.post<any>(`/companies/`, data);
  // }
}
